(function(){
  function norm(s){return (s||'').toString().trim().toLowerCase().replace(/\s+/g,'');}
  function currentSize(){
    var sels=document.querySelectorAll('select[name^="options"], select[data-index], .variant-input-wrap select');
    for(var i=0;i<sels.length;i++){
      var lab=(sels[i].closest('.variant-wrapper')||document).querySelector('label');
      var name=sels[i].getAttribute('data-name')||sels[i].name||'';
      if(/frame\s*size/i.test(name)||(lab&&/frame\s*size/i.test(lab.textContent))) return sels[i].value;
    }
    var radios=document.querySelectorAll('input[type=radio]:checked');
    for(var j=0;j<radios.length;j++){if(/frame\s*size/i.test(radios[j].name||'')) return radios[j].value;}
    return null;
  }
  function highlight(){
    var s=norm(currentSize());
    document.querySelectorAll('.ve-geo [data-size]').forEach(function(c){
      c.classList.toggle('is-selected', !!s && norm(c.getAttribute('data-size'))===s);
    });
  }
  document.addEventListener('change',function(e){if(e.target&&(e.target.tagName==='SELECT'||e.target.type==='radio'))setTimeout(highlight,50);});
  document.addEventListener('variant:change',function(){setTimeout(highlight,50);});
  if(document.readyState!=='loading')highlight();else document.addEventListener('DOMContentLoaded',highlight);
})();
